import { useMemo } from 'react';

import useGet from 'lib/hooks/useGet';
import { UPB_VIEWER_BETA_KPI_METRICS } from 'lib/networking/endpoints';

/**
 * useUPBBetaKpiMetrics — fetches the 7 KPI metrics for the UPB Viewer Beta strip.
 *
 * All category params are optional. Omitting all returns the global (all-categories) totals.
 *
 * Returns { data, loading, error, refetch }
 * data shape: {
 *   annualized_gmv, total_skus, active_skus, gmv_skus,
 *   avg_ecom_score, avg_attribute_score, total_l4s
 * }
 */
function useUPBBetaKpiMetrics({
  l1CategoryId,
  l2CategoryId,
  l3CategoryId,
  l4CategoryId,
  vendorId,
  thirdPartyTag,
  skip = false,
} = {}) {
  const params = useMemo(() => {
    const p = {};
    if (l1CategoryId) p.l1_category_id = l1CategoryId;
    if (l2CategoryId) p.l2_category_id = l2CategoryId;
    if (l3CategoryId) p.l3_category_id = l3CategoryId;
    if (l4CategoryId) p.l4_category_id = l4CategoryId;
    if (vendorId) p.vendor_id = vendorId;
    if (thirdPartyTag) p.third_party_tag = thirdPartyTag;
    return p;
  }, [l1CategoryId, l2CategoryId, l3CategoryId, l4CategoryId, vendorId, thirdPartyTag]);

  return useGet(UPB_VIEWER_BETA_KPI_METRICS, params, skip);
}

export default useUPBBetaKpiMetrics;
